import { render, staticRenderFns } from "./process_q.vue?vue&type=template&id=49aed26f&scoped=true"
import script from "./process_q.vue?vue&type=script&lang=js"
export * from "./process_q.vue?vue&type=script&lang=js"
import style0 from "./process_q.vue?vue&type=style&index=0&id=49aed26f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49aed26f",
  null
  
)

export default component.exports